/**
 * Whether the reader has asked for reduced motion.
 *
 * Read at the moment a transition would start rather than subscribed to: the
 * only thing that reacts to a mid-flight change of this setting is the next
 * transition, which is soon enough and costs no listener per open surface.
 */
export const prefersReducedMotion = (): boolean =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
